import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { PredefinedMessagesFiltersProps } from '@/types/predefined-messages';

import { MultiSelectFilterPopover } from '@/components/configuration-modal/multi-select-filter-popover';
import { Input } from '@/components/ui/input';

export function PredefinedMessagesFilters({
  filters,
  roleFilterOptions,
  recipientRoleOptions,
}: PredefinedMessagesFiltersProps) {
  const {
    query,
    onQueryChange,
    availableToFilter,
    onToggleAvailableTo,
    onSelectAllAvailableTo,
    onClearAvailableTo,
    recipientsFilter,
    onToggleRecipient,
    onSelectAllRecipients,
    onClearRecipients,
  } = filters;

  const { t } = useTranslation();

  return (
    <div className="mt-2 flex flex-wrap items-center justify-between gap-4">
      <div className="relative w-full max-w-md">
        <Input
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder={t('common:configuration.predefinedMessages.searchPlaceholder')}
          className="pl-9 focus-visible:ring-0"
          type="text"
          inputMode="search"
          autoComplete="off"
          aria-label={t('common:configuration.predefinedMessages.searchPlaceholder')}
        />
        <span className="text-muted-foreground pointer-events-none absolute top-1/2 left-3 -translate-y-1/2">
          <Search className="text-foreground h-4 w-4" aria-hidden />
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <MultiSelectFilterPopover
          label={t('common:configuration.predefinedMessages.filterByAvailableTo')}
          options={roleFilterOptions}
          selectedIds={availableToFilter}
          onToggle={onToggleAvailableTo}
          onSelectAll={onSelectAllAvailableTo}
          onClear={onClearAvailableTo}
        />
        <MultiSelectFilterPopover
          label={t('common:configuration.predefinedMessages.filterByRecipients')}
          options={recipientRoleOptions}
          selectedIds={recipientsFilter}
          onToggle={onToggleRecipient}
          onSelectAll={onSelectAllRecipients}
          onClear={onClearRecipients}
        />
      </div>
    </div>
  );
}
